// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/api/organizations/firstparty/v5/get_features.proto

/* oxlint-disable */

/** Request for getting features for an organization. */
export interface ApiGetFeaturesRequest {
  /** The organization ID. */
  readonly id: string;
}

/** Response containing a list of features. */
export interface ApiGetFeaturesResponse {
  /** List of feature names. */
  readonly features: readonly string[];
}

export const ApiGetFeaturesRequest: MessageFns<ApiGetFeaturesRequest> = {
  fromJSON(object: any): ApiGetFeaturesRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: ApiGetFeaturesRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    return obj;
  },
};

export const ApiGetFeaturesResponse: MessageFns<ApiGetFeaturesResponse> = {
  fromJSON(object: any): ApiGetFeaturesResponse {
    return {
      features: globalThis.Array.isArray(object?.features)
        ? object.features.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ApiGetFeaturesResponse): unknown {
    const obj: any = {};
    if (message.features?.length) {
      obj.features = message.features;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
